import  angular from 'angular';
import  'angular-ui-bootstrap';
import  'angular-ui-router';
import  'angular-animate';
import  'angular-moment';
import  'angular-sanitize';
import  'angular-i18n/angular-locale_es-es.js';
import 'moment/locale/es.js';

const MODULE_NAME = 'buscador.core.dependencies';

var ngModule=angular.module(MODULE_NAME, [
                            'ui.bootstrap',
                            'ui.router',
                            'ngAnimate',
                            'angularMoment'                    
]);


export default MODULE_NAME;



// WEBPACK FOOTER //
// ./src/busqueda/core/dependencies.js